import type { ReactNode } from 'react';
import clsx from 'clsx';
import { useUIStore } from '@/shared/stores/ui-store';
import { useSSENotifications } from '@/shared/hooks/use-sse-notifications';
import { AppHeader } from '@/shared/components/layout/AppHeader';
import { AppSidebar } from '@/shared/components/layout/AppSidebar';
import styles from './AppShell.module.scss';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed);

  // Establish SSE connection for real-time notifications
  useSSENotifications();

  return (
    <div className={styles.shell}>
      <AppSidebar />
      <div className={clsx(styles.content, sidebarCollapsed && styles.contentCollapsed)}>
        <AppHeader />
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
}
